import { useTranslation } from 'react-i18next';
import TrendArrow from './TrendArrow';
import { getDisplayValue } from './utils';
import DataCard, { DataCardDisplayProps } from './DataCard';

type TotalCardProps = DataCardDisplayProps;

const TotalCard = ({
  change,
  showEmpty = false,
  label,
  src,
  type,
  value,
  unit = '',
  noPreviousData = false,
}: TotalCardProps) => {
  const { t } = useTranslation();

  return (
    <DataCard type={type}>
      <img className="image" src={src} alt={label} />
      <div className="w-full flex justify-end text">
        <div className="mr-6">
          <p className="display-value">
            {showEmpty ? '— —' : getDisplayValue(value, unit)}
          </p>
          <p className="text-sm font-semibold align-top">{label}</p>
          {showEmpty && <p className="text-xs">{t('analytics.noValidData')}</p>}
          {!showEmpty && (
            <>
              {noPreviousData ? (
                <p className="text-xs">
                  {t('analytics.trafficAwarenessPage.overview.noPrevious')}
                </p>
              ) : (
                <TrendArrow
                  change={change}
                  label={t('analytics.fromThePreviousPeriod')}
                />
              )}
            </>
          )}
        </div>
      </div>
    </DataCard>
  );
};

export default TotalCard;
